module.exports = __webpack_public_path__ + "static/img/9.4702d86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/9.png
// module id = +LXz
// module chunks = 0